import { motion } from 'framer-motion'
import styled from 'styled-components'

import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { VisibleScrollbarStyle } from '@/styles/scrollbar'

const StContainer = styled.div`
  height: 100%;
  padding-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
  ${VisibleScrollbarStyle};
`

const StErrorContainer = styled.div`
  height: 100%;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-bottom: 0px;
`

const StErrorText = styled(P)`
  padding: 0px ${({ theme }) => theme.UI.SpacingPx.Space8};
`

const AnimatedContainer = motion(StContainer)
const AnimatedErrorContainer = motion(StErrorContainer)

export { AnimatedContainer, AnimatedErrorContainer, StErrorContainer, StErrorText }
